// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Read from env vars so key rotations don't require code changes. The
// hardcoded fallbacks match the current production project ref + new
// publishable key format (sb_publishable_...), which is what edge functions
// require after the 2026-07-29 legacy-JWT deprecation. The old anon JWT
// (iat 1758514791) is still accepted by PostgREST but is rejected by edge
// functions with `UNAUTHORIZED_LEGACY_JWT`.
const SUPABASE_URL =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ??
  "https://txoojazdivnmgstunpic.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) ??
  "sb_publishable_BTebPqXtNv_ToyA-x-ka_A_RCqoKj90";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});